/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';

function MessageBox({ messages }: { messages: any }) {
 const [open, setOpen] = useState(false);
 const { enqueueSnackbar, closeSnackbar } = useSnackbar();

 const handleCloseSnackbar = (key: any) => {
  closeSnackbar(key);
 };

 useEffect(() => {
  messages.forEach((message: any) => {
   if (!message.message) {
    console.log('empty toast message', message);
   } else {
    enqueueSnackbar(message.message || 'empty message', {
     variant: message.type,
     nanoid: message.id,
     autoHideDuration: 3000,
     ContentProps: {
      classes: {
       root: {
        content: {
         backgroundColor: 'red !important',
        },
       },
      },
     },
    });
   }
  });
 }, [messages]);

 //  const dispatch = useDispatch();
 //  const messages = useSelector((state: RootState) => state.toast.messages);

 //  const handleClose = () => {
 //   setOpen(false);
 //   dispatch(clearToast());
 //  };

 //  useEffect(() => {
 //   if (messages) {
 //    setOpen(true);
 //    const timer = setTimeout(() => {
 //     dispatch(clearToast());
 //     setOpen(false);
 //    }, 10000);
 //    return () => {
 //     clearTimeout(timer);
 //    };
 //   }
 //   return () => false;
 //  }, [messages, dispatch]);

 return null;
 //  return (
 //   <Stack spacing={2}>
 //    {messages?.map((message, index) => (
 //     <Snackbar
 //      key={message.id}
 //      open={open}
 //      autoHideDuration={10000}
 //      onClose={handleClose}
 //      ClickAwayListenerProps={{ onClickAway: () => null }} // do not close on clickaway
 //      anchorOrigin={{
 //       vertical: 'bottom',
 //       horizontal: 'right',
 //      }}
 //      sx={{ maxWidth: '600px' }}
 //      // action={action}
 //     >
 //      <Alert
 //       onClose={handleClose}
 //       variant="filled"
 //       sx={{ width: '100%', color: 'white' }}
 //       severity={message.type || 'info'}
 //      >
 //       {message.message || 'Empty toast message'}
 //      </Alert>
 //     </Snackbar>
 //    ))}
 //   </Stack>
 //  );
}
export default MessageBox;
